import React, { useEffect } from 'react'
import { View, StyleSheet, Image } from 'react-native'
import { useNavigation } from '@react-navigation/core'

import { useUniverseConfig } from '../../../hooks/Universe'

import MainContainer from '../../../components/MainContainer/MainContainer'
import CustomPressable from '../../../components/pressables/CustomPressable'
import { CustomText } from '../../../components/text/StyledText'
import Colors from '../../../constants/Colors'
import Layout from '../../../constants/Layout'
import { txt } from '../../../locales/i18n'
import NormalIcon from '../../../components/icons/NormalIcon'

export default function StartboblenOffersScreen() {
	const navigation = useNavigation()
	const universeObject = useUniverseConfig()

	useEffect(() => {
		navigation.setOptions({
			headerTitle: () => (
				<Image
					style={styles.logo}
					resizeMode="contain"
					source={{ uri: universeObject?.logo }}
					accessibilityLabel={universeObject?.logoLabel}
					accessibilityIgnoresInvertColors
					accessibilityRole="image"
				/>
			)
		})
	}
	, [])

	return (
		<MainContainer backgroundColor={universeObject.backgroundColor}>
			<View style={styles.container}>

				<CustomText font="largeBold" style={{marginBottom: 16}}>{'Velkommen indenfor i Startboblen'}</CustomText>
				<CustomText style={{marginBottom: 16}}>{'Startboblen er Startlinjens trygge onlineunivers på Boblberg - for dig, der gerne vil øve dig i sociale færdigheder og finde fællesskab med andre i samme situation. \n\nHer kan du deltage i små gruppeforløb og interessefællesskaber, hvor vi sammen bliver stærkere i det sociale - uden krav om at være perfekt. \n\nDu vælger selv, om du vil være med i relationsklubben eller interesseklubben - eller i dem begge.'}</CustomText>

				<View style={{ alignItems: 'center'}}>
					<CustomPressable
						style={styles.card}
						onPress={() => navigation.navigate('UniverseGroupsStack', { screen: 'Groups' })}
					>
						<View style={styles.textContainer}>
							<CustomText font="largeBold" style={styles.cardTitle}>{'Startboblens Relationsklub'}</CustomText>
							<CustomText font={"small"}>{'Et gruppeforløb med fokus på social træning. Vi mødes online og arbejder med konkrete værktøjer i små, trygge grupper ledet af erfarne facilitatorer.'}</CustomText>
						</View>
						<View>
							<NormalIcon name="chevron-right" size={14} color={'#00A9A0'} style={styles.icon} />
						</View>
					</CustomPressable>

					<CustomPressable
						style={styles.card}
						onPress={() => navigation.navigate('UniverseGroupsStack', { screen: 'Groups' })}
					>
						<View style={styles.textContainer}>
							<CustomText font="largeBold" style={styles.cardTitle}>{'Startboblens Meditationsklub'}</CustomText>
							<CustomText font={"small"}>{'Et roligt fællesskab med guidet meditation og nærvær. Vi mødes online i små, faste grupper og deler stilhed, refleksion og samhørighed - i trygge rammer og helt uden præstationskrav.'}</CustomText>
						</View>
						<View>
							<NormalIcon name="chevron-right" size={14} color={'#00A9A0'} style={styles.icon} />
						</View>
					</CustomPressable>

					<CustomPressable
						style={styles.card}
						onPress={() => navigation.navigate('UniverseBoblStack', { screen: 'Bobls' })}
					>
						<View style={styles.textContainer}>
							<CustomText font="largeBold" style={styles.cardTitle}>{'Boblberg'}</CustomText>
							<CustomText font={"small"}>{'Fordi du er en del af Startboblen, har du også adgang til Boblberg - en platform, hvor du kan finde fællesskaber og dele interesser med andre, der søger det samme som dig.'}</CustomText>
						</View>
						<View style={{alignItems: 'flex-end'}}>
							<NormalIcon name="chevron-right" size={14} color={'#00A9A0'} style={styles.icon} />
						</View>
					</CustomPressable>
				</View>

			</View>
		</MainContainer>
	)
}

const styles = StyleSheet.create({
	container: {
		alignSelf: 'center',
		marginHorizontal: 12,
		marginBottom: 48,
		maxWidth: Layout.isSmallDevice ? '100%' : Layout.maxFeedWidth,
	},
	card: {
		flexDirection: 'row',
		alignItems: 'center',
		maxWidth: Layout.isSmallDevice ? '100%' : 500,
		width: '100%',

		backgroundColor: Colors.white,
		borderRadius: 8,
		paddingHorizontal: 24,
		paddingVertical: 24,
		marginBottom: 24,

		/* SHADOW */
		shadowColor: Colors.grey,
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.1,
		shadowRadius: 20,
		elevation: 15,
	},
	cardTitle: {
		marginBottom: 8,
		color: '#00A9A0',
	},
	textContainer: {
		flex: 1,
	},
	icon: {
		width: 16,
		height: 16,
		marginLeft: 8,
	},
	logo: {
		alignSelf: 'center',
		height: 32,
		marginRight: Layout.isSmallDevice ? 0 : 16,
		width: 200,
	},
})
